<template>
  <div style="display:none">
    <!-- <button @click="beginDetect">Detect</button> -->
    <p>Level：<span id="audio-value">null</span></p>
    <p>Weired Sound：<span id="audio-threshold">null</span></p>
    {{timer}}
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "WeiredSound",
  data() {
    return {
      audioContext: null,
      mediaStreamSource: null,
      meter: null,
      processor:null,
      count: 0,
      timer:null,
      les:null,
    };
  },
  methods: {
    beginDetect() {
      this.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => 
        {
          this.mediaStreamSource = this.audioContext.createMediaStreamSource(
            stream
          );
          this.meter = this.createAudioMeter(this.audioContext);
          this.mediaStreamSource.connect(this.meter);
        });
      }
    },
    createAudioMeter(actx, clipLevel, averaging, clipLag) {
      this.processor = actx.createScriptProcessor(512);
      this.processor.onaudioprocess = this.volumeAudioProcess;


      this.processor.clipping = false;
      this.processor.lastClip = 0;
      this.processor.volume = 0;
      this.processor.clipLevel = clipLevel || 0.98;
      this.processor.averaging = averaging || 0.95;
      this.processor.clipLag = clipLag || 750;

      // this will have no effect, since we don't copy the input to the output,
      // but works around a current Chrome bug.
      this.processor.connect(actx.destination);

      this.processor.checkClipping = function() {
        if (!this.processor.clipping) {
          return false;
        }
        if (this.processor.lastClip + this.processor.clipLag < window.performance.now()) {
          this.processor.clipping = false;
        }
        return this.processor.clipping;
      };

      this.processor.shutdown = function() {
        this.processor.disconnect();
        this.processor.onaudioprocess = null;
      };
       //console.log('this>>'+processor.clipLevel)
      return this.processor;
    },

    volumeAudioProcess(event) {
      const buf = event.inputBuffer.getChannelData(0);
      const bufLength = buf.length;
      let sum = 0;
      let x;
      // Do a root-mean-square on the samples: sum up the squares...
      for (var i = 0; i < bufLength; i++) {
        x = buf[i];
        if (Math.abs(x) >= this.processor.clipLevel) {
          this.processor.clipping = true;
          this.processor.lastClip = window.performance.now();
        }
        sum += x * x;
      }
      // ... then take the square root of the sum.
      const rms = Math.sqrt(sum / bufLength);
      // Now smooth this out with the averaging factor applied
      // to the previous sample - take the max here because we
      // want "fast attack, slow release."
      this.processor.volume = Math.max(rms, this.processor.volume * this.processor.averaging);
      if(document.getElementById("audio-value")!=null)
        document.getElementById("audio-value").innerHTML = this.processor.volume;

      if (this.processor.volume >= 0.3) {
       // console.log(this.processor.volume)
        if(this.timer==null || Date.now()>this.timer+300000){
          //sleep(2000);
          if(document.getElementById("audio-threshold")!=null)
            document.getElementById("audio-threshold").innerHTML = this.processor.volume;
            //audio is detected store in log
          this.storeaudiodetection(this.processor.volume);
           this.timer = Date.now()
        }
       
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    storeaudiodetection(value)
    {
      console.log("value:"+value)
      const fd={
        audio_val:value,
        lesid:this.les.les_id
      }
      axios.post( 'student/pushAudio',
      fd,
      ).then(function(){
      console.log('SUCCESS!!');
      })
      .catch(function(){
      console.log('FAILURE!!');
      });
      // this.processor.disconnect();
      // sleep(100)
      // this.detect
        //alert(value)
        
        //var ajax = new XMLHttpRequest();
        //ajax.open("GET","http://localhost:8080/LearnerExamProctoringLog/storeaudio?value="+value,true);
        //async: true (asynchronous) or false (synchronous)
        //ajax.send();
    }
  },
  mounted() {
    if (localStorage.getItem("stud_ques_ans_list") == "") {
      this.$router.push({ name: "stud-start-exam" });
      return;
    }
    this.beginDetect()
    this.les = JSON.parse(localStorage.getItem("les"));
  },
  beforeDestroy(){
    if(this.processor!=null){
      this.processor.disconnect();
      this.processor.onaudioprocess = null;
    }
    console.log("audio stop")
  },
};
</script>
<style scoped></style>
